import { req } from "vuelidate/lib/validators/common";

export default (value: string) => {
  // Check if a value has been passed in
  if (!req(value)) {
    return true;
  }

  const accountNumberRegex = /^7[0-9]{7}$/;

  const isValid = accountNumberRegex.test(value);

  return isValid;
};
